import React from "react";
import CountUp from "react-countup";
import { useInView } from 'react-intersection-observer';

type Stat = {
  value: number;
  suffix: string;
  label: string;
};

type StatsSectionProps = {
  stats: Stat[];
};

type StatItemProps = {
  stat: Stat;
};

const StatItem: React.FC<StatItemProps> = ({ stat }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  return (
    <div
      className="px-2 sm:px-4 py-2 max-[500px]:px-0 max-[500px]:py-6 max-[500px]:text-left max-[500px]:w-full"
      ref={ref}
    >
      <h3
        className="font-utility font-medium text-[54px] leading-[120%] tracking-[-0.01em] align-middle capitalize text-[#011621] max-[500px]:text-[30px] max-[500px]:font-bold max-[500px]:mb-2 max-[500px]:text-left"
      >
        {inView ? (
          <CountUp
            end={stat.value}
            duration={2}
            decimals={stat.suffix.includes('M') ? 1 : 0}
          />
        ) : stat.suffix.includes('M') ? stat.value.toFixed(1) : stat.value}
        {stat.suffix}
      </h3>
      <p
        className="font-inter font-normal text-[20px] leading-[150%] tracking-[-0.005em] text-[#033652] mx-auto max-[500px]:text-[18px] max-[500px]:leading-[140%] max-[500px]:mt-1 max-[500px]:text-left max-[500px]:mx-0"
      >
        {stat.label}
      </p>
    </div>
  );
};

const StatsSection: React.FC<StatsSectionProps> = ({ stats }) => (
  <div className="bg-white sm:py-[59px] sm:px-[79px] px-4 py-8 max-w-full ">
    <div
      className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 divide-x-2 divide-gray-300 text-center
      max-[500px]:grid-cols-1 max-[500px]:divide-x-0 max-[500px]:gap-0 max-[500px]:border-gray-200 max-[500px]:text-left"
    >
      {stats.map((stat, index) => (
        <React.Fragment key={index}>
          <StatItem stat={stat} />
          {index !== stats.length - 1 && (
            <div
              className="hidden max-[500px]:block border-t-4 border-[#B3C3CB] my-2 ml-0"
              style={{ transform: 'rotate(0deg)' }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
    <div className="font-inter font-normal text-[16px] leading-[150%] tracking-[-0.005em] text-[#4F7286] mt-7 ml-5 !border-[white] max-[500px]:ml-0 max-[500px]:text-left max-[500px]:text-[13px] max-[500px]:-mt-2 max-[500px]:mb-6 max-[500px]:text-[#7A8B99]">Please note: All data presented relates to SKTUFF as a group company from 2007 to 2025.</div>
  </div>
);

export default StatsSection; 